// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dynamic-table-container {
  box-shadow: 0 8px 32px rgba(0, 85, 0, 0.15) !important;
  border: 1px solid rgba(255, 192, 34, 0.2) !important;
  transition: all 0.3s ease !important;
}

.dynamic-table-container:hover {
  transform: translateY(-2px) !important;
}

@media (max-width: 768px) {
  .dynamic-table-container {
    margin: 0 -16px !important;
    border-radius: 0 !important;
  }
}
`, "",{"version":3,"sources":["webpack://./src/Components/Dynamic/DynamicTable.css"],"names":[],"mappings":"AAAA;EACE,sDAAsD;EACtD,oDAAoD;EACpD,oCAAoC;AACtC;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE;IACE,0BAA0B;IAC1B,2BAA2B;EAC7B;AACF","sourcesContent":[".dynamic-table-container {\n  box-shadow: 0 8px 32px rgba(0, 85, 0, 0.15) !important;\n  border: 1px solid rgba(255, 192, 34, 0.2) !important;\n  transition: all 0.3s ease !important;\n}\n\n.dynamic-table-container:hover {\n  transform: translateY(-2px) !important;\n}\n\n@media (max-width: 768px) {\n  .dynamic-table-container {\n    margin: 0 -16px !important;\n    border-radius: 0 !important;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
